import { createContext } from 'react'
const PosDownloadContext = createContext('Default Value')
export default PosDownloadContext